import { useCallback, useEffect, useState } from "react";
import {
  getCachedAccessToken,
  getStoredAccessTokenIgnoringExpiry,
} from "@/integrations/auth/client";
import {
  refreshAccessToken,
  startTokenManager,
  subscribeToToken,
} from "@/integrations/auth/token-manager";

export function useAuthToken() {
  // Seed with the last-known token (even if expired) so that offline
  // startup can mount Zero and serve cached local data. Once online, the
  // token manager refreshes and pushes the new value through.
  const [token, setToken] = useState<string | null>(
    () => getCachedAccessToken() ?? getStoredAccessTokenIgnoringExpiry(),
  );

  useEffect(() => {
    startTokenManager();
    return subscribeToToken(setToken);
  }, []);

  const forceRefresh = useCallback(() => refreshAccessToken("force"), []);

  return { token, forceRefresh };
}
